module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBoldItalic.322adef.eot";